import {useLocation, useNavigate} from "react-router-dom";
import {useEffect, useRef, useState} from "react";
import Loader from "../../Loader";
import objectDataHolder from "../../Hooks/ObjectDataHolder";
import _axios from "../../../httpService";
import {prefixUrl} from "../../../utils/utilsData";
import {toast} from "react-toastify";
import {sampleData} from "./data";
import SectionView from "./SectionView";
import "./SettingPagePermissionOptions.scss"
import {selectAll} from "./permissionFunctions"
import Button from "../../UI/Button";
import RoleSection from "./RoleSection";

const SettingPagePermissionOptions = () => {

  const myLocation = useLocation()
  const navigateTo = useNavigate();
  const [loader, setLoader] = useState(true)
  const [kmo, setKmo] = useState("")
  const [data, setData] = objectDataHolder(sampleData);
  const [roles, setRoles] = objectDataHolder({
    activeConfiguration: false,
    array: [],
    selectedRole: ''
  });
  const [showAdvance, setShowAdvance] = useState(false)

  const submitHandler = () => {
    toast('در حال ارسال اطلاعات')
    const send = _axios.post(prefixUrl() + '/permissions/?request=setPermissions', {
      permissions: data,
      user: kmo
    }).then(res => {
      if (res.data.status) {
        navigateTo(-1)
      }
    });


    toast.promise(send, {
      pending: "در حال ارسال... لطفا صبر کنید.",
      success: "اطلاعات ثبت شد.",
      error: "ثبت اطلاعات با خطا رو به رو  شد ",
    });
  }

  const userAccessFormRef = useRef()

  // function toggle(e) {
  //   let checkboxes = userAccessFormRef.current.querySelectorAll("input");
  //   for (var checkbox of checkboxes) checkbox.checked = e.target.checked;
  // }

  useEffect(() => {
    const kmo = myLocation?.state?.kmo || '';
    setKmo(kmo)
    if (kmo) {
      const getUserAccessInfoRequest =

        // _axios.get(prefixUrl() + "/permissions/?user=" +kmo + "&request=permissionOptions"+ "&part=" + 'constants').then(res=>{})
        // _axios.get(prefixUrl() + "/permissions/?user=" +kmo + "&request=permissionOptions"+ "&part=" + 'List').then(res=>{})
        // _axios.get(prefixUrl() + "/permissions/?user=" +kmo + "&request=permissionOptions"+ "&part=" + 'operation').then(res=>{})

        _axios.get(prefixUrl() + "/permissions/?user=" + kmo + "&request=permissionOptions")
          .then((response) => {
            if (response.data.status) {
              setData(response.data.permissionOptions);

              if (response.data.roles.status) {
                setRoles({array: response.data.roles.roles});
              }
              if (response.data.showAdvancedPermissions) {
                setShowAdvance(response.data.showAdvancedPermissions)
              }

              setLoader(false)
            } else {
              toast.error(response.data.message)
            }

          });
      toast.promise(getUserAccessInfoRequest, {
        pending: "در حال دریافت  دسترسی های کاربر",
        success: " دسترسی ها با موفقیت دریافت شد",
        error: "دریافت  دسترسی ها با مشکل مواجه شد",
      });
    } else {
      alert("مقادیر ورودی را چک کنید")
      navigateTo("/setting")
    }
  }, [])

  const selectAllHandler = (e) => {
    setData(selectAll(data, e.target.checked))

  }

  const reverseActive = () => {

    const activeConfiguration = !roles.activeConfiguration
    setRoles({activeConfiguration})
  }
  const changeRoleHandler = (selectedRole) => {

    setRoles({selectedRole})
    const result = _axios.get(prefixUrl() + '/permissions/?request=roleConfig' + '&role=' + selectedRole).then(res => {
      if (res.data.status) {
        setData(res.data.permissionOptions)
      }
    })


    toast.promise(result, {
      pending: `در حال دریافت  دسترسی های ` + `${selectedRole}`,
      success: " دسترسی ها با موفقیت دریافت شد",
      error: "دریافت  دسترسی ها با مشکل مواجه شد",
    });

  }
  const saveRoleHandler = () => {

    const result = _axios.post(prefixUrl() + '/permissions/?request=setRoleConfig', {
      permissions: data,
      role: roles.selectedRole,
    }).then(res => {
      if (res.data.status) {
        reverseActive();
      }
    });

    toast.promise(result, {
      pending: `در حال ثبت دسترسی های  ` + `${roles.selectedRole}`,
      success: " اطلاعت ثبت شد.",
      error: "دریافت  دسترسی ها با مشکل مواجه شد",
    });

  }
  return (<>
    {loader ? <Loader/> : <>

      {data && <div className={"SettingPagePermissionOptions"}>
        <h5>
          ویرایش دسترسی های کاربر:
          {kmo}
        </h5>

        {roles.array.length > 0 && <div
          style={{
            width: '100%',
            height: '80px',
            margin: '20px 0',
          }}

          className={'background__gray mx-auto rounded-3 d-flex justify-content-around align-items-center'}>
          <RoleSection roles={roles}
                       reverseActive={reverseActive}
                       onChange={changeRoleHandler}
                       onSave={saveRoleHandler}

          />
        </div>}
        <div>
          <input
            onChange={selectAllHandler}
            id={'sa'} type="checkbox"/>
          <label htmlFor='sa'>انتخاب همه</label>
        </div>
        <legend>دسترسی های کلی</legend>
        <SectionView
          sectionKey={"constants"}
          data={data}
          setData={setData}
          showAdvance={showAdvance}
        />
        <legend>فهرست ها</legend>
        <SectionView
          sectionKey={'List'}
          data={data}
          setData={setData}
          showAdvance={showAdvance}

        />
        <legend>عملیات ها</legend>
        <SectionView
          sectionKey={'operation'}
          data={data}
          setData={setData}
          showAdvance={showAdvance}
        />

        <div className={'d-flex justify-content-center align-items-center'}>
          <button
            className={'mx-3 btn btnCustom btnSubmit submit-button'}
            onClick={submitHandler}
          >
            تایید
          </button>
          <button
            className={'btn btn-outline-danger dashboard-bill-close'}
            onClick={() => navigateTo(-1)}
          >
            انصراف
          </button>
        </div>
      </div>}
    </>}
  </>);
};

export default SettingPagePermissionOptions;
